const baseUrl = process.env.APP_BASEURL;

export const userApi = {
  UserInfo: baseUrl + '/auth/me',
  UserProfile: baseUrl + '/user/profile',
  unsubscribe: baseUrl + '/user/unsubscribe',
  UserReglementationInfo: baseUrl + '/user/reglementation-info',
  UploadFile: baseUrl + '/user/upload-file',
  GetUploadedFile: baseUrl + '/user/uploaded-file',
  SlackNotification: baseUrl + '/user/slack-notification',
  SaveReferralSource: baseUrl + '/user/referral-source',
};
